import type { SearchRequest } from './types';

/**
 * Client-side cache key. Mirrors the rounding the server uses in
 * `functions/lib/cache.ts` so both layers group the same requests together - if these
 * drift apart the client cache silently stops matching and every search costs a call.
 */
const COORD_PRECISION = 3;

function round(value: number, places: number): number {
  const factor = 10 ** places;
  return Math.round(value * factor) / factor;
}

export function canonicalKey(request: SearchRequest): string {
  return JSON.stringify({
    q: request.textQuery.trim().toLowerCase(),
    lat: round(request.center.lat, COORD_PRECISION),
    lng: round(request.center.lng, COORD_PRECISION),
    r: Math.round(request.radiusM),
    t: request.includedType ?? '',
    p: [...(request.priceLevels ?? [])].sort(),
    o: request.openNow ?? null,
    m: request.minRating ?? null,
    rank: request.rankPreference ?? 'RELEVANCE',
  });
}
